import { message } from 'antd';
import { config } from 'util/config';
import { httpClient } from "util/Api";
import { operationalFunction } from 'components/UIBuilder/SectionFunction/Common';
import * as globalFunction from 'util/GlobalFunction';

export function addEssentialServiceTemplate({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  sectionComponent.setState({ showModal: true, componentType: 'Create' });
  pageComponent.setState({ defaultFormData: { essentialServiceTemplateFolderId: parameter.EssentialServiceTemplateFolderId } });
  setTimeout(() => {
    let formData = parameter;
    sectionComponent.customForm.current?.formRef.current?.setFieldsValue(formData);
    sectionComponent.customForm.current?.setState({ formData });
  }, config.setTimeoutMilliSecond);
}

export function manageEssentialServiceTemplateFolder({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  sectionComponent.child.current?.setState({ manageFolderShow: true });
  sectionComponent.child.current?.manageFolder.current?.getEssentialServiceTemplateFolderList();
}

export function addBySection({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  sectionComponent.setState({ showModal: true, componentType: 'Create', isFormModified: false });
  pageComponent.setState({ defaultFormData: { essentialServiceTemplateFolderId: parameter.EssentialServiceTemplateFolderId } });
}

export function collapseAllParts({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  let data = sectionComponent.child.current?.state.data.map((folder, i) => {
    folder.EssentialServicePartOrderList.map((part, i) => {
      part.Collapsed = true;
      return part;
    });
    return folder;
  });
  setTimeout(() => {
    sectionComponent.child.current?.setState({ data });
  }, config.setTimeoutMilliSecond);
}

export function editEssentialServiceTemplatePopUpRun({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  pageComponent.setState({ defaultFormData: { essentialServiceTemplateFolderId: parameter.EssentialServiceTemplateFolderId } });
}
